import managementReports from './modules/management-reports'
import properties from './modules/properties'
import propertysSales from './modules/property-sales'
import realEstateDevelopments from './modules/real-estate-developments'
import sales from './modules/sales'
import salesCompletions from './modules/sales-completions'
import settings from './modules/settings'
import myApprovals from './modules/my-approvals'
import onlendings from './modules/onlendings'

import { setDefaultFiltersBeforeEnter } from 'asteroid'

const routes = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        name: 'Root',
        path: '',
        redirect: { name: 'Dashboard' }
      },
      {
        name: 'Dashboard',
        path: '/dashboard',
        beforeEnter: setDefaultFiltersBeforeEnter,
        component: () => import('src/pages/dashboard/Dashboard.vue')
      },

      ...managementReports,

      ...properties,

      ...propertysSales,

      ...realEstateDevelopments,

      ...sales,

      ...salesCompletions,

      ...settings,

      ...myApprovals,

      ...onlendings
    ]
  }
]

export default routes
